<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi"
                                           ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesMstMaterialResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" inlineActionsDisabled
                                      :query-api="$_emWorkflowListMixin_queryApi"
                                      :ref="modelName+'Table'" editDisable>
                                <template #left-header>
                                    <b-button-group>
                                        <em-button type="search"
                                                   v-if="pathType === 'todo'"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   :customLabel="isClaim ? '认领' : '待办'"
                                                   :custom-icon="'fa ' + (isClaim ? 'fa-toggle-on' : 'fa-toggle-off')"
                                                   :busy="emWorkflowListLoading"
                                                   show-name
                                                   @click="switchClaim">
                                        </em-button>
                                        <em-button type="task"
                                                   v-if="pathType !== 'list'"
                                                   :busy="claimLoading"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   :custom-label="isClaim ? '认领' : '处理'"
                                                   @click="handleExecuteBatch()">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author Lin
// Date 2022-09-26 10:59:31
import emWorkflowListMixin from "@/mixin/em/workflow/list";
import ClaimTaskMixins from "@/components/workflow/mixin/ClaimTaskMixins";

export default {
    name: "sithMesMstMaterialWorkflowListView",
    mixins: [emWorkflowListMixin, ClaimTaskMixins],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    }
};
</script>